<template>
    <oss-dialog
        ref="dateDialog"
        v-model="dateDialog"
        :return-value="dateRange"
        persistent
        title
        @close="close()"
        width="550px"
    >
        <template v-slot:activator="{ props }">
            <v-text-field
                :label="label"
                prepend-inner-icon="$oss-calendar"
                readonly
                outlined
                :hide-details="hideDetails"
                :data-cy="prefixDataCy + '-date'"
                :class="fullTextFieldClass"
                v-if="!hideActivator"
                v-model="formatDateRange"
                density="compact"
                v-bind="props"
            />
        </template>

        <v-row no-gutters>
            <v-col cols="12" class="d-flex justify-center">
                <v-date-picker-wrapper
                    v-model="dateRange"
                    :first-day-of-week="1"
                    multiple="range"
                    scrollable
                    hide-header
                    :type="type"
                    :disabled="disabled"
                    :allowed-dates="allowedDates"
                    :data-cy="prefixDataCy + '-calendar'"
                >
                </v-date-picker-wrapper>
            </v-col>
        </v-row>

        <template v-slot:actions>
            <v-btn-primary block @click="valid()" :data-cy="prefixDataCy + '-date-ok'" size="large"
                >Valider</v-btn-primary
            >
        </template>
    </oss-dialog>
</template>

<script lang="ts">
import { Component, toNative } from "vue-facing-decorator";
import { ossDateRangePickerBase } from "./ossDateRangePickerBase";

@Component
export class ossDateRangePicker extends ossDateRangePickerBase {}

export default toNative(ossDateRangePicker);
</script>
